/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

const Counters = () => {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={12} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard count={820} suffix="+" title="Registered IPD-Beded HCUs" />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard count={1750} suffix="+" title="Registered OPD-Non Beded HCUs" />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard count={20} suffix="+" title="Years of experience" />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard count={300} suffix="+" title="Tons of Waste Collected Per Year" />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
};

export default Counters;
